import { useEffect } from "react";

/**
 * Hook to preserve scrollbar when modals are opened and closed
 * Fixes the issue where Radix UI dialogs remove the scrollbar and don't restore it
 */
export const useScrollbarPreservation = (isOpen: boolean) => {
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;

    if (isOpen) {
      // Get scrollbar width before hiding it
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      // Store original values
      const originalOverflow = document.body.style.overflow;
      const originalPaddingRight = document.body.style.paddingRight;

      // Apply styles to prevent scroll while preserving layout
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      // Cleanup function
      return () => {
        document.body.style.overflow = originalOverflow;
        document.body.style.paddingRight = originalPaddingRight;
      };
    }
  }, [isOpen]);
};

/**
 * Alternative approach for cases where we need more control
 */
export const useBodyScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (!isLocked) return;

    const originalStyle = window.getComputedStyle(document.body);
    const scrollY = window.scrollY;
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    // Apply lock styles
    Object.assign(document.body.style, {
      position: "fixed",
      top: `-${scrollY}px`,
      width: "100%",
      paddingRight: `${scrollbarWidth}px`,
      overflow: "hidden",
    });

    return () => {
      // Restore original styles
      Object.assign(document.body.style, {
        position: "",
        top: "",
        width: "",
        paddingRight: "",
        overflow: "",
      });

      // Restore scroll position
      window.scrollTo(0, scrollY);
    };
  }, [isLocked]);
};
